import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './http'
import auth from './auth'
import filters from './filters'
import validator from './validator'
import forms from './components/form-controls'
import dialog from './components/dialog'
import i18n from './i18n'
import VueToast from 'vue-toast-notification'
import VTooltip from 'v-tooltip'

//styles
// import 'vue-toast-notification/dist/theme-default.css';
import './scss/main.scss'

Vue.use(http)
Vue.use(auth)
Vue.use(filters)
Vue.use(forms)
Vue.use(dialog)
Vue.use(validator)

Vue.use(VueToast)
Vue.use(VTooltip)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
